document.addEventListener("DOMContentLoaded", function () {
  const popupOverlay = document.querySelectorAll(".popup-overlay");
  const closePopupBtn = document.querySelectorAll(".close-btn");
  const blocks = document.querySelectorAll(".pop-function-banner");
  const allPopups = document.querySelectorAll(".popup-block");


  blocks.forEach((block) => {
    block.addEventListener("click", function () {
      const blockId = block.getAttribute("block-id");
      console.log("block button clicked")
      // Hide all popups
      allPopups.forEach(p => p.classList.add("hidden"));

      // Show only the clicked block's popup
      const targetPopup = document.getElementById("popup-" + blockId);
      if (targetPopup) targetPopup.classList.remove("hidden");

      
      // Show overlay
      overLay = targetPopup.closest('#popup-overlay');
      overLay.style.display = "block"
      // popupOverlay.style.display = "block";
     document.body.style.overflow = 'hidden';

     
  
    });
  });
 closePopupBtn.forEach(clBtn=>{
  clBtn.addEventListener("click", function () {
    console.log("close")
    overLay.style.display = "none";
    allPopups.forEach(p => p.classList.add("hidden"));
    document.body.style.overflow = 'auto';
  });
 })


  // Close popup when clicking outside the window
  popupOverlay.forEach((popup)=>{
    popup.addEventListener("click", function (e) {
      console.log("outside close")
      if (e.target === popup) {
      overLay.style.display = "none";
      allPopups.forEach(p => p.classList.add("hidden"));
      document.body.style.overflow = 'auto';
      }
  });
})
});
